import apiClient from './axios';

export const requestOtpForLogin = (phone) => {
    return apiClient.post('/auth/login/request-otp', { phone });
};

export const verifyOtpForLogin = (payload) => {
    return apiClient.post('/auth/login/verify-otp', payload);
};

